import { DeletableItem } from 'taboola-ultimate-ui';
import { useFields } from 'modules/push-api/hooks/useFields';
import { FormNamespaceProvider } from 'modules/taboola-common-frontend-modules/formData/FormNamespaceProvider';
import { SubscriptionAddItemButton } from '../SubscriptionAddItemButton/SubscriptionAddItemButton';
import { SubscriptionField } from '../SubscriptionField/SubscriptionField';
import styles from './subscriptionEntityFields.module.scss';

export const SubscriptionEntityFields = ({ itemKey, entityIndex }) => {
    const { fields, addField, deleteField } = useFields();

    return (
        <FormNamespaceProvider field="fields" itemKey={itemKey}>
            {fields?.map(({ id: key }, index) => {
                return (
                    <FormNamespaceProvider field={index} itemKey={key} key={`field_${key}`}>
                        <DeletableItem onDelete={() => deleteField(index)} className={styles['inlineButton']}>
                            <SubscriptionField itemKey={`field_${key}`} entityIndex={entityIndex} fieldIndex={index} />
                        </DeletableItem>
                    </FormNamespaceProvider>
                );
            })}
            <SubscriptionAddItemButton onClick={addField} label="Add Field" />
        </FormNamespaceProvider>
    );
};
